module.exports = __webpack_public_path__ + "img/iron-throne-3.1728c978.png";